import React, { useContext } from "react";
import ArenkoUIAlertSnackbar from "@arenko-group/arenko-ui/dist/components/AlertSnackbar";
import { DataTestContext } from "@arenko-group/arenko-ui/dist/components/AuthorisedApp";
import { closeSnackbar } from "@/features/alertSnackbarSlice";
import { useAppDispatch, useAppSelector } from "@/storeHooks";

const AlertSnackbar = () => {
  const dataTestId = useContext(DataTestContext);
  const dispatch = useAppDispatch();
  const snackbarOpen = useAppSelector((state) => state.snackbar.snackbarOpen);
  const snackbarAutoCloseDuration = useAppSelector(
    (state) => state.snackbar.snackbarAutoCloseDuration
  );
  const alertSeverity = useAppSelector((state) => state.snackbar.alertSeverity);
  const alertMessage = useAppSelector((state) => state.snackbar.alertMessage);

  return (
    <ArenkoUIAlertSnackbar
      dataTestId={dataTestId}
      position={{ vertical: "top", horizontal: "right" }}
      open={snackbarOpen}
      autoHideDuration={snackbarAutoCloseDuration}
      onClose={() => dispatch(closeSnackbar())}
      alertSeverity={alertSeverity}
      alertMessage={alertMessage}
    />
  );
};

export default AlertSnackbar;
